export const startPopup = (e: React.MouseEvent<HTMLButtonElement>) => {
	const div = document.createElement('div');

	div.innerText = 'Copied';

	div.style.position = 'fixed';
	div.style.top = `${e.clientY - 30}px`;
	div.style.left = `${e.clientX - 25}px`;
	div.style.fontSize = '12px';
	div.style.color = '#5ccdde';
	div.style.border = '1px solid #5ccdde';
	div.style.borderRadius = '4px';
	div.style.padding = '3px';
	div.style.background = '#fff';
	div.style.lineHeight = '1.2';
	div.setAttribute('id', 'copy-click');

	if (!document.getElementById('copy-click')) document.body.appendChild(div);

	setTimeout(() => {
		div.remove();
	}, 2000);
};

export const checkTagLength = (tags: string[]) => {
	return tags.find((tag) => {
		return tag.length < 3 || tag.length > 25;
	});
};

export const fsTags = {
	'low intent': {
		label: 'Low Intent',
		color: '#E6FFFA',
	},
	'mid intent': {
		label: 'Mid Intent',
		color: '#B2F5EA',
	},
	'mid-high intent': {
		label: 'Mid-High Intent',
		color: '#81E6D9',
	},
	'high intent': {
		label: 'High Intent',
		color: '#4FD1C5',
	},
	'active customer': {
		label: 'Active Customer',
		color: '#FFFAF0',
	},
	loyal: {
		label: 'Loyal Customer',
		color: '#FEEBCB',
	},
	'very loyal': {
		label: 'Very Loyal Customer',
		color: '#FBD38D',
	},
};

export const isAITag = (tag: string) => tag.includes('ai:');

export const getAITagTransformed = (tag: string) => {
	const tagElements = tag.split(':');
	const tagGrp = tagElements[1];
	const detail = tagElements[2];
	const notFound = { label: 'uknown', color: 'backgroundColors.white' };

	switch (tagGrp) {
		case 'fs': {
			return detail
				? fsTags[detail as keyof typeof fsTags]
					? {
							label: fsTags[detail.toLowerCase() as keyof typeof fsTags].label,
							color: fsTags[detail.toLowerCase() as keyof typeof fsTags].color,
					  }
					: { label: detail, color: 'backgroundColors.white' }
				: notFound;
		}
		case 'ic':
			return detail ? { label: 'Interested in ' + detail, color: '#BEE3F8' } : notFound;
		case 'p1': {
			const label = 'Low purchase intent';
			return { label, color: '#FAF5FF' };
		}
		case 'p2': {
			const label = 'Mid purchase intent';
			return { label, color: '#E9D8FD' };
		}
		case 'p3': {
			const label = 'High purchase intent';
			return { label, color: '#D6BCFA' };
		}
		case 'pc1': {
			const label = 'Low purchase intent';
			return detail ? { label: label + ' ' + detail, color: '#FFF5F7' } : { label, color: '#FFF5F7' };
		}
		case 'pc2': {
			const label = 'Mid purchase intent';
			return detail ? { label: label + ' ' + detail, color: '#FED7E2' } : { label, color: '#FED7E2' };
		}
		case 'pc3': {
			const label = 'High purchase intent';
			return detail ? { label: label + ' ' + detail, color: '#FBB6CE' } : { label, color: '#FBB6CE' };
		}
		case 'ib':
			return detail ? { label: 'Interested in ' + detail, color: '#9DECF9' } : notFound;
		case 'pb1': {
			const label = 'Low purchase intent';
			return detail ? { label: label + ' ' + detail, color: '#FAF089' } : { label, color: '#FAF089' };
		}
		case 'pb2': {
			const label = 'Mid purchase intent';
			return detail ? { label: label + ' ' + detail, color: '#F6E05E' } : { label, color: '#F6E05E' };
		}
		case 'pb3': {
			const label = 'High purchase intent';
			return detail ? { label: label + ' ' + detail, color: '#ECC94B' } : { label, color: '#ECC94B' };
		}
		default:
			return notFound;
	}
};
